// extracted by mini-css-extract-plugin
export default {"login":"styles_login__LS1M+","loginAndroidBadge":"styles_loginAndroidBadge__he9wb","loginFlexbox":"styles_loginFlexbox__20JVi","loginWholePage":"styles_loginWholePage__aDXU6"};